import apiClient from './client.js';
const base = (wsId) => `/workspaces/${wsId}/ai-gateway`;

export const chat = (wsId, dto) => apiClient.post(`${base(wsId)}/chat`, dto).then(r => r.data);
export const createSession = (wsId, dto) => apiClient.post(`${base(wsId)}/sessions`, dto).then(r => r.data);
export const listSessions = (wsId) => apiClient.get(`${base(wsId)}/sessions`).then(r => r.data);
export const getSession = (wsId, sessionId) => apiClient.get(`${base(wsId)}/sessions/${sessionId}`).then(r => r.data);
export const listTemplates = (wsId) => apiClient.get(`${base(wsId)}/templates`).then(r => r.data);
export const createTemplate = (wsId, dto) => apiClient.post(`${base(wsId)}/templates`, dto).then(r => r.data);
export const updateTemplate = (wsId, id, dto) => apiClient.patch(`${base(wsId)}/templates/${id}`, dto).then(r => r.data);
export const deleteTemplate = (wsId, id) => apiClient.delete(`${base(wsId)}/templates/${id}`).then(r => r.data);
export const renderTemplate = (wsId, slug, vars) => apiClient.post(`${base(wsId)}/templates/${slug}/render`, { variables: vars }).then(r => r.data);
